import { canAccessPath } from './accessPolicy'

const commonCommands = [
  { key: 'dashboard', title: 'ダッシュボード', subtitle: '今日の打刻・アクション・月次状況', route: '/dashboard', icon: 'cil-speedometer', keywords: 'home ホーム' },
  { key: 'roster', title: '勤務表', subtitle: '日々の勤務実績を入力', route: '/report/roster', icon: 'cil-calendar-check', keywords: '勤怠 タイムシート' },
  { key: 'monthly-report', title: '業務報告', subtitle: '月次の業務内容を報告', route: '/report/monthlyreport', icon: 'cil-description', keywords: '月報' },
  { key: 'expense', title: '経費精算', subtitle: '業務経費を登録・申請', route: '/payoff/expense', icon: 'cil-wallet', keywords: '精算 領収書' },
  { key: 'commute', title: '通勤費精算', subtitle: '通勤経路・交通費を登録', route: '/payoff/travelCost', icon: 'cil-bus-alt', keywords: '交通費 定期' },
  { key: 'leave', title: '休暇申請', subtitle: '有休・代休・特休・欠勤を申請', route: '/paidandsubstitutes/list', icon: 'cil-sun', keywords: '有給 代休 特休 欠勤' },
  { key: 'leave-planner', title: '有休取得計画', subtitle: '残数・取得目標・次回付与を確認', route: '/insights/paid-leave', icon: 'cil-calendar', keywords: '有給 5日 付与 残数' },
  { key: 'submission-list', title: '自分の申請一覧', subtitle: '自分の提出状況を確認', route: '/submission_approval/report_list', icon: 'cil-inbox', keywords: '提出 申請' },
  { key: 'approval-list', title: '承認待ちの申請', subtitle: '自分に届いた申請を確認', route: '/submission_approval/submission_management', icon: 'cil-check-circle', keywords: '承認 差戻し' },
  { key: 'projects', title: 'プロジェクト', subtitle: '所属・利用可能なプロジェクトを確認', route: '/project/list', icon: 'cil-layers', keywords: '案件 PJ' },
  { key: 'clients', title: '取引先情報', subtitle: '取引先の一覧を確認', route: '/client/list', icon: 'cil-building', keywords: '会社 顧客 取引先 クライアント' },
  { key: 'departments', title: '部署一覧', subtitle: '部署と組織図を確認', route: '/department/list', icon: 'cil-building', keywords: '組織 所属 部署' }
]

const managementCommands = [
  { key: 'workforce-heatmap', title: '稼働状況分析', subtitle: '日別の所属・勤務時間をヒートマップ表示', route: '/admin/insights/workforce', icon: 'cil-grid', keywords: '人員 稼働 アサイン ヒートマップ' },
  { key: 'monthly-total', title: '月次集計', subtitle: 'スタッフの月次勤務集計', route: '/admin/total/list', icon: 'cil-list-rich', keywords: '勤務時間 集計' },
  { key: 'roster-admin', title: '勤務表一覧', subtitle: '全スタッフの勤務表を確認', route: '/admin/roster/list', icon: 'cil-list-rich', keywords: '勤怠 管理' },
  { key: 'users', title: 'ユーザー管理', subtitle: 'スタッフ情報を検索・更新', route: '/users/list', icon: 'cil-people', keywords: '社員 メンバー ユーザ' },
  { key: 'settings', title: '自社設定', subtitle: '会社・勤怠・通知設定を管理', route: '/setting/info', icon: 'cil-settings', keywords: '会社 Slack 通知' },
  { key: 'tenant-access', title: '権限管理', subtitle: '権限グループ・権限・社員への割り当てを管理', route: '/admin/tenant-access-management', icon: 'cil-shield-alt', keywords: 'ロール Permission 権限 権限グループ 役割' }
]

const adminCommands = [
  { key: 'project-summary', title: 'プロジェクト集計', subtitle: '売上・原価・稼働を月次集計', route: '/admin/total/list_project', icon: 'cil-chart-pie', keywords: '粗利 採算' },
  { key: 'project-rate', title: 'プロジェクト金額設定', subtitle: '基本請求額・月額原価を設定', route: '/admin/project-rate', icon: 'cil-money', keywords: '単価 金額 原価 請求' },
  { key: 'sales', title: '請求書管理', subtitle: '売上登録と請求書出力', route: '/admin/sales/salesManagement', icon: 'cil-layers', keywords: '請求 売上 PDF 請求書発行 売上管理' },
  { key: 'profit-forecast', title: 'プロジェクト収益予測', subtitle: '売上・原価・粗利の着地を予測', route: '/admin/insights/project-profit', icon: 'cil-chart-pie', keywords: '利益 粗利 採算 予算' },
  { key: 'cash-flow', title: '入出金予測', subtitle: '支払期日別の入金見込みを確認', route: '/admin/insights/cash-flow', icon: 'cil-money', keywords: 'キャッシュフロー 請求 入金 支払期日' },
  { key: 'overtime-limit-status', title: '36協定アラート', subtitle: '時間外・休日労働の上限に触れている方を確認', route: '/admin/insights/overtime-limits', icon: 'cil-warning', keywords: '36協定 上限 時間外 休日労働 特別条項 720時間' },
  { key: 'platform-access', title: '契約企業一覧', subtitle: '契約・プラン・利用可能機能を管理', route: '/platform/access-management', icon: 'cil-building', keywords: '契約企業 プラン Feature' }
]

const allCommands = [...commonCommands, ...managementCommands, ...adminCommands]

/**
 * 出す画面を決める。**利用機能が分からないときは、1件も出さない。**
 *
 * 権限だけで決める道が残っていた。権限は合っていても、その会社が
 * 契約していない機能・まだ出していない機能がある。利用機能を取れて
 * いないあいだにここを通ると、<b>メニューにも直接URLにも出ない画面が、
 * 検索窓からだけ出てくる。</b>塞ぎ方を1本にした意味が無くなる。
 *
 * 取れていないのは一瞬（読み込み中）か、取得に失敗したときだけ。
 * どちらも「分からない」であって「使える」ではない。
 */
export function commandPaletteItems (accessContext) {
  if (!accessContext || typeof accessContext !== 'object') return []
  return allCommands.filter(item => canAccessPath(accessContext, item.route))
}

export function filterCommandPaletteItems (items, query) {
  const normalized = String(query || '').trim().toLowerCase()
  if (!normalized) return items.slice(0, 12)
  return items
    .map(item => {
      const title = String(item.title || '').toLowerCase()
      const target = `${item.title || ''} ${item.subtitle || ''} ${item.keywords || ''}`.toLowerCase()
      let score = 9
      if (title === normalized) score = 0
      else if (title.startsWith(normalized)) score = 1
      else if (target.includes(normalized)) score = 3
      return { ...item, score }
    })
    .filter(item => item.score < 9)
    .sort((left, right) => left.score - right.score || left.title.localeCompare(right.title, 'ja'))
    .slice(0, 12)
}
